/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import styled from 'styled-components';
import TriStateCheckbox, {TriState} from '../../common/buttons/TriStateCheckbox';

const HnaZoneLegendWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > div {
    display: flex;
    padding: 12px;
    align-items: center;
    justify-content: center;
    gap: 32px;
    border-radius: 8px;
    background: #1c262f;
    width: fit-content;
  }
`;

const HnaZoneLegendItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const HnaZoneLegendItemLabel = styled.span`
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

const HnaZoneLegend = () => {
  const LEGEND_ENTRIES = [
    {
      status: TriState.Unavailable,
      label: 'Not Requested',
    },
    {
      status: TriState.Blank,
      label: 'No Response',
    },
    {
      status: TriState.Approved,
      label: 'Request Approved',
    },
    {
      status: TriState.Denied,
      label: 'Request Denied',
    },
  ];

  return (
    <HnaZoneLegendWrapper>
      <div>
        {LEGEND_ENTRIES.map(entry => (
          <HnaZoneLegendItem key={entry.status}>
            <TriStateCheckbox readOnly={true} status={entry.status} sx={{ color: '#465967', fontSize: '1.5rem', display: 'flex' }} />
            <HnaZoneLegendItemLabel>{entry.label}</HnaZoneLegendItemLabel>
          </HnaZoneLegendItem>
        ))}
      </div>
    </HnaZoneLegendWrapper>
  );
};

export default HnaZoneLegend;
